<script lang="ts">
    import { api } from '../../../stores/api';
    import { openModal } from 'svelte-modals';
    import { get } from 'svelte/store';
    import { _ } from 'svelte-i18n';

    import ModalRemoveSomething from '../Modals/ModalRemoveSomething.svelte';
    import { getFilterQuery } from './getFilterQuery';
    import ModalError from '../../shared/Modals/ModalError.svelte';
    import IconRemove from '../../shared/Icons/IconRemove.svelte';
    import IconClose from '../../shared/Icons/IconClose.svelte';
    import { routes } from '../../../stores/store';
    import { app } from '../../../stores/app';
    import { ConnectionApi } from './ConnectionApi';
    import { RouteApi } from '../Route/RouteApi';
    import IconRoute from '../../shared/Icons/IconRoute.svelte';
    import type { QueriesType } from '../telematics/types';
    import { NotificationSystem } from '../NotificationSystem/NotificationSystem';
    import { canWrite, writeDisabledTooltip } from '../../shared/Permissions/writeAccess';

    let selectedCount: number = 0;
    let limitExceeded: string = '';

    function triggerRouteRecalculation() {
        // Route::triggerRouteRecalculation jest na liście BLOCKED_CUSTOM_OPERATIONS - backend odda 403
        if (!get(canWrite)) {
            return;
        }
        let query: QueriesType;
        if ($routes.selectMode === 'selected') {
            query = {
                $and: [getFilterQuery(), { id: { $in: $routes.selectedOrUnselected } }],
            };
        } else {
            query = {
                $and: [getFilterQuery(), { id: { $nin: $routes.selectedOrUnselected } }],
            };
        }
        console.log('triggerRouteRecalculation', query);
        RouteApi.triggerRouteRecalculation(get(api), query)
            .then(response => {
                console.log('remove jobs', response);
            })
            .catch(error => {
                console.warn('remove jobs', error);
                openModal(ModalError, {
                    message: $_('some_jobs_could_not_be_modified'),
                });
            })
            .finally(() => {
                $routes.selectedOrUnselected = [];
                $routes.selectMode = 'selected';
                $routes.forceRecount = true;
                $routes.forceReload = true;
                $NotificationSystem.reload();
            });
    }

    $: {
        if ($routes.selectMode === 'selected') {
            selectedCount = $routes.selectedOrUnselected.length;
        } else {
            selectedCount = $routes.countFiltered.count - $routes.selectedOrUnselected.length;
        }
        limitExceeded = '';
        if (!$app.settingsReadonly?.allow_limit_exceeding && $app.settingsReadonly?.max_transactions_per_month !== null) {
            if ($routes.currentTransactionCount.count >= $app.settingsReadonly?.max_transactions_per_month) {
                limitExceeded = 'transaction_limit_exceeded';
            } else if ($routes.currentTransactionCount.count + selectedCount > $app.settingsReadonly?.max_transactions_per_month) {
                limitExceeded = 'transaction_limit_will_be_exceeded';
            }
        }
    }
</script>

<div class="lm--action_bar" style="display: flex;">
    <div>
        <span class="text-span-10">{$_('Selected items')}</span>:
        <strong>{selectedCount}</strong>
    </div>
    <div class="lm--action_bar_loptions">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div title={$canWrite ? (limitExceeded ? $_(limitExceeded, {values: {limit: $app.settingsReadonly?.max_transactions_per_month}}) : '') : $_(writeDisabledTooltip)}>
            <div
                class="lm--icon_with_text"
                class:write-blocked={!$canWrite || limitExceeded}
                on:click={triggerRouteRecalculation}
            >
                <IconRoute scale={0.7} />
                <div>{$_('set_routes_to_recalc')}</div>
            </div>
        </div>
        <IconClose
            scale={0.7}
            on:click={() => {
                $routes.selectedOrUnselected = [];
                $routes.selectMode = 'selected';
            }}
        />
    </div>
</div>

<style>
    .lm--action_bar {
        font-size: 14px;
        z-index: 1;
        height: 68px;
        color: #fff;
        background-color: #397be5;
        justify-content: space-between;
        align-items: center;
        padding: 10px 30px;
        display: none;
        position: absolute;
        top: -46px;
        /*bottom: auto;*/
        left: 0;
        right: 0;
    }
    .lm--action_bar_loptions {
        grid-column-gap: 30px;
        grid-row-gap: 30px;
        /*filter: invert();*/
        color: #000;
        align-items: center;
        font-weight: 500;
        line-height: 14px;
        display: flex;
    }
    .lm--icon_with_text {
        grid-column-gap: 5px;
        grid-row-gap: 5px;
        cursor: pointer;
        align-items: center;
        display: flex;
        filter: invert();
    }
    /* przy braku can_write akcja nie lapie klikniec, a tooltip siedzi na obudowie */
    .lm--icon_with_text.write-blocked {
        pointer-events: none;
        opacity: 0.4;
        cursor: not-allowed;
    }
</style>
